/** Public Encaja CRM URLs (shared with crm_ui brand). */
export const ENCAJA_SITE_URL = 'https://encaja.estumejoropcion.com';
export const ENCAJA_LOGIN_URL = 'https://encaja.estumejoropcion.com/login';
/** Anchor on estumejoropcion.com homepage — Encaja plans live in the product catalog. */
export const ENCAJA_PLANS_ANCHOR = '#productos-encaja';
